import type { RouteObject } from "react-router-dom";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import { ThisWeek } from "./pages/ThisWeek";
import { Requests } from "./pages/Requests";
import { RequestDetail } from "./pages/RequestDetail";
import { MyWork } from "./pages/MyWork";
import { Accounts } from "./pages/Accounts";
import { Milestones } from "./pages/Milestones";
import { Capacity } from "./pages/Capacity";
import { RequirePilot } from "./components/PilotOnly";
import { MilestoneDetail } from "./pages/MilestoneDetail";
import { AccountDetail } from "./pages/AccountDetail";
import { SettingsSla, SettingsTags, SettingsTeam } from "./pages/Settings";
import { RequireAdmin } from "./components/RequireAdmin";
import { accountLoader, accountsLoader, capacityLoader, milestonesLoader, milestoneLoader, dashboardLoader, myWorkLoader, requestLoader, requestsLoader, tagsLoader, teamLoader } from "./data/loaders";
import { ErrorScreen } from "./pages/ErrorScreen";
import { NotFound } from "./pages/NotFound";

/**
 * The route tree, exported so tests build a memory router from the very same
 * definition rather than a parallel copy that can drift. App is the layout
 * element (auth gate + sidebar frame); each screen renders into its Outlet.
 *
 * Real path routing works because the Worker serves index.html for unknown
 * paths (§8.5), so a deep link like /requests/CE-1042 resolves to the SPA
 * rather than a 404 from the edge.
 */
export const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorScreen />,
    children: [
      { index: true, element: <ThisWeek />, loader: dashboardLoader },
      { path: "requests", element: <Requests />, loader: requestsLoader },
      { path: "requests/:id", element: <RequestDetail />, loader: requestLoader },
      { path: "my-work", element: <MyWork />, loader: myWorkLoader },
      { path: "milestones", element: <Milestones />, loader: milestonesLoader },
      { path: "capacity", element: <RequirePilot><Capacity /></RequirePilot>, loader: capacityLoader },
      { path: "milestones/:id", element: <MilestoneDetail />, loader: milestoneLoader },
      { path: "accounts", element: <Accounts />, loader: accountsLoader },
      { path: "accounts/:id", element: <AccountDetail />, loader: accountLoader },
      { path: "settings/sla", element: <RequireAdmin><SettingsSla /></RequireAdmin> },
      { path: "settings/team", element: <RequireAdmin><SettingsTeam /></RequireAdmin>, loader: teamLoader },
      { path: "settings/tags", element: <RequireAdmin><SettingsTags /></RequireAdmin>, loader: tagsLoader },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
